import { type AbstractControl, type FormGroup } from '@angular/forms';

export type ControlTabMap<TTab extends string> = Record<TTab, string[]>;

export function countErrorsByTab<TTab extends string>(
  form: AbstractControl,
  map: ControlTabMap<TTab>,
): Record<TTab, number> {
  const result = {} as Record<TTab, number>;

  for (const tab of Object.keys(map) as TTab[]) {
    let count = 0;

    for (const controlName of map[tab]) {
      if (form.get(controlName)?.invalid) {
        count++;
      }
    }

    result[tab] = count;
  }

  return result;
}

export function findUnmappedControls(
  form: FormGroup,
  map: ControlTabMap<string>,
): string[] {
  const mapped = new Set(Object.values(map).flat());

  return Object.keys(form.controls).filter((name) => !mapped.has(name));
}
